import React, { useEffect, useState } from 'react';
import { Container } from 'ui/components/4-habitats/Container';
import { widthMapper } from 'helpers/mappers/widthMapper';
import type { CustomMapProps } from 'ui/components/3-organisms/CustomMap/';
import { spacingMapper } from 'helpers/mappers/spacingMapper';
import { useDictionaryContext } from 'application/contexts/DictionaryContext';
import dynamic from 'next/dynamic';

export const CustomMapFeature: React.FC<Content.CustomMap> = ({ content }) => {
	const { markerList, width, spacing, apiKey } = content?.properties ?? {};
	const culture = useDictionaryContext();
	const [isApiKeyValid, setIsApiKeyValid] = useState<boolean | null>(null);

	// Validate API key before passing to map
	useEffect(() => {
		const validateApiKey = async () => {
			if (!apiKey || apiKey.trim() === '') {
				setIsApiKeyValid(false);
				return;
			}

			try {
				// Test the API key with a simple MapTiler request
				const testUrl = `https://api.maptiler.com/maps/streets-v2/?key=${apiKey}`;
				const response = await fetch(testUrl);

				if (response.ok) {
					setIsApiKeyValid(true);
				} else {
					setIsApiKeyValid(false);
				}
			} catch (error) {
				setIsApiKeyValid(false);
			}
		};

		validateApiKey();
	}, [apiKey]);

	const mappedMarkers =
		markerList?.map((marker: Content.CustomMapMarker) => ({
			latitude: marker.Properties.latitude,
			longitude: marker.Properties.longitude,
			title: marker.Properties.title,
			description: marker.Properties.description,
			markerIcon: marker.Properties.markerIcon,
		})) ?? [];

	if (!isApiKeyValid) return null;

	const DynamicCustomMap = dynamic<CustomMapProps>(
		() => import('ui/components/3-organisms/CustomMap').then((module) => module.CustomMap),
		{
			// ssr: false,
		},
	);

	return (
		<Container width={widthMapper(width)} spacingBottom={spacingMapper(spacing)} section>
			<DynamicCustomMap {...content?.properties} markers={mappedMarkers} culture={culture} />
		</Container>
	);
};
